mod.modules.define("ResearchNotes", "BaseModule", function (fn) {

	fn.prototype.init = function (params) {
		this.base("init", params);

		var $noteBodies = this.el.find(".textBody");

		var DotDotHeight = 50;

		if (this.el.find("span.readMore").length > 0) {
			DotDotHeight = 35;
		}

		if ($noteBodies.length) {
			$noteBodies.dotdotdot({
				height: DotDotHeight,
				tolerance: 0,
				wrap: 'letter'
			});
		}
	};

});